import React from 'react';
import { Item } from '../styles/carousel-item.style';

/**
 * Carousel Component
 * @param {*} props Incoming Props
 * @returns {XML} A carousel of items
 */
const CarouselItem = ({ children, ...rest }) => <Item {...rest}>{children}</Item>;

export default CarouselItem;



// WEBPACK FOOTER //
// ./src/components/carousel/components/carousel-item.js